<template>
    <header id="main-header" class="main-header" :class="{ 'scrolled-version': showScrolledVersion() }"
        v-if="$route.name !== 'Login'">
        <div class="container">
            <button class="mobile-toggle-btn" @click="toggleMobileMenu" :class="{ 'toggled-btn': showMobileMenu }"></button>
            <span class="main-logo">
                <router-link class="logo-link" @click="hidePopups" to="/">
                    <img class="logo" alt="Logo" src="@/assets/svgs/logo.svg" />
                </router-link>
            </span>

            <div class="inner-menu-container">
                <nav class="main-nav" id="main-nav">
                    <ul>
                        <li>
                            <router-link @click="hidePopups" to="/videos/">All videos</router-link>
                        </li>
                        <li class="contains-sub-menu">
                            <button class="has-children" @click="hidePopups" to="/videos/"
                                :class="{ 'active': this.$route.name === 'VideoCategoryPage' }">Days</button>
                            <ul class="sub-menu">
                                <li><router-link @click="hidePopups" to="/videos/day-1/">Day 1</router-link></li>
                                <li><router-link @click="hidePopups" to="/videos/day-2/">Day 2</router-link></li>
                                <li><router-link @click="hidePopups" to="/videos/day-3/">Day 3</router-link></li>
                                <li><router-link @click="hidePopups" to="/videos/day-4/">Day 4</router-link></li>
                            </ul>
                        </li>
                    </ul>
                </nav>
                <nav class="side-nav" id="side-nav">
                    <ul>
                        <li>
                            <SearchBar />
                        </li>
                        <li class="login-btn" v-if="!isAuthenticated">
                            <button class="regular" @click="loginPopup">Login</button>
                        </li>
                        <li class="contains-sub-menu" v-if="isAuthenticated">
                            <button class="regular has-children">
                                My profile
                            </button>
                            <ul class="sub-menu">
                                <li>
                                    <router-link to="/account">Settings</router-link>
                                </li>

                                <li><button @click="handleLogout()">Logout</button></li>
                            </ul>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </header>

    <transition name="slide-in">
        <div id="mobile-nav" class="mobile-nav" v-if="showMobileMenu && $route.name !== 'Login'"
            :class="{ 'scrolled-home-v': removeLoginBar }">
            <nav>
                <ul>
                    <li>
                        <router-link @click="hidePopups" to="/videos/">All videos</router-link>
                    </li>
                    <li><router-link @click="hidePopups" to="/videos/day-1/">Day 1</router-link></li>
                    <li><router-link @click="hidePopups" to="/videos/day-2/">Day 2</router-link></li>
                    <li><router-link @click="hidePopups" to="/videos/day-3/">Day 3</router-link></li>
                    <li><router-link @click="hidePopups" to="/videos/day-4/">Day 4</router-link></li>
                    <span class="line"></span>
                    <li class="login-btn" v-if="!isAuthenticated">
                        <button class="regular-style" @click="loginPopup">Login</button>
                    </li>
                    <li>
                        <router-link to="/account">My profile</router-link>
                    </li>

                    <li v-if="isAuthenticated">
                        <button class="regular-style" @click="handleLogout()">
                            Logout
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    </transition>
    <!-- <transition name="fade">
		<LoginPopup
			v-if="$store.state.displayLoginPopup"
			@forgotPasswordClicked="forgotPasswordPopup"
		/>
	</transition>
	<transition name="fade">
		<ForgotPasswordPopup
			@showLoginPopupAgain="loginPopup"
			v-if="$store.state.displayPasswordPopup"
		/>
	</transition> -->
</template>

<script>
import { mapState } from "vuex";
import { getUserToken, getUserInfo, clearData } from "@streampac.io/chef_sp_1";
//@import component
// import LoginPopup from "@/components/LoginPopup";
// import ForgotPasswordPopup from "@/components/ForgotPasswordPopup";

import SearchBar from "@/components/SearchBar";

//let scrollObject = {};
// let scrollPosition = 0;

// function getScrollPosition() {
// 	let mainHeader = document.getElementById('main-header');

// 	let st = window.scrollY;

// 	if (scrollPosition > 60) {
// 		//Scroll down
// 		mainHeader.classList.add('remove-extra-menu');
// 	} else {
// 		//Scroll up
// 		mainHeader.classList.remove('remove-extra-menu');
// 	}

// 	if (scrollPosition > 200) {
// 		//Scroll down
// 		mainHeader.classList.add('scrolled-down');
// 	} else {
// 		//Scroll up
// 		mainHeader.classList.remove('scrolled-down');
// 	}

// 	scrollPosition = st;
// }

// window.onscroll = getScrollPosition;

export default {
    data() {
        return {
            userData: null,
            showMobileMenu: false,
            removeExtraMenu: false,
            removeLoginBar: false,
        };
    },
    inject: ["isAuthenticated", "setAuthenticated"],
    components: {
        // LoginPopup,
        // ForgotPasswordPopup,
        SearchBar,
    },
    watch: {
        $route() {
            this.$store.commit("hideLoginPopup");
            this.$store.commit("hidePasswordPopup");
            this.showMobileMenu = false;

            setTimeout(() => {
                let mainHeader = document.getElementById("main-header");
                mainHeader.classList.remove("scrolled-down");
            }, 50);
        },
        storeIsAuthenticated(val) {
            if (val == true) {
                this.storeUserInfo();
            }
        },
    },
    created() {
        if (this.isAuthenticated) {
            this.storeUserInfo();
        }
        let scrollPosition = 0;

        const getScrollPosition = () => {
            let mainHeader = document.getElementById("main-header");

            let st = window.scrollY;

            if (scrollPosition > 50) {
                //Scroll down
                mainHeader.classList.add("scrolled-down");
            } else {
                //Scroll up
                mainHeader.classList.remove("scrolled-down");
            }

            scrollPosition = st;
        };

        window.onscroll = getScrollPosition;
    },
    updated: function () {
        if (this.isAuthenticated) {
            this.$store.commit("hideLoginPopup");
            this.$store.commit("hidePasswordPopup");
        }
    },
    computed: mapState(["storeIsAuthenticated"]),
    methods: {
        storeUserInfo() {
            setTimeout(() => {
                getUserToken((token) => {
                    this.setUserDetails(token);
                });
            }, 300);
        },
        handleLogout() {
            clearData();
            this.setAuthenticated(false);
            this.$store.commit("storeRemoveAuthenticatedStatus");
            this.$store.commit("deleteUserSavedData");
            this.$router.replace({ name: "Home" });
        },
        loginPopup() {
            this.$store.commit("toggleLoginPopup");
        },
        forgotPasswordPopup() {
            this.$store.commit("hideLoginPopup");
            this.$store.commit("showPasswordPopup");
        },
        setUserDetails(token) {
            getUserInfo(token).then((response) => {
                this.userData = response;
                this.$store.commit("setUserData", response);
            });
        },
        hidePopups() {
            this.$store.commit("hideLoginPopup");
            this.$store.commit("hidePasswordPopup");
        },
        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu;
        },
        showScrolledVersion() {
            // if (!this.$store.state.getBodyBackgroundUrl && this.$route.name !== 'VideoDetails') {
            //     return true;
            // }
            return true;
            // if (this.showMobileMenu) {
            //     return true;
            // } else if (!this.$store.state.getBodyBackgroundUrl) {
            //     return true;
            // }

            // if (this.$store.state.getBodyBackgroundUrl) {
            //     console.log(this.$store.state.getBodyBackgroundUrl);
            //     return true;
            // }
        }
    },
};
</script>

<style lang="scss" scoped>
// @import styles
@import "./index.scss";
</style>

<style lang="scss">
@media only screen and (max-width: $mobileSize) {
    .home.not-logged-in {
        .mobile-nav nav {
            margin-top: 60px;
            transition: 0.3s;
        }

        .mobile-nav.scrolled-home-v nav {
            margin-top: 0;
        }

        .mobile-extra-header-nav {
            top: 140px;
        }

        .main-header {
            top: 0;
            margin-top: 60px;
            position: sticky;
        }

        main {
            margin-top: -80px;
        }
    }
}
</style>
